import React, { useContext } from 'react';
import Chevron from '../../foundations/pictograms/chevron_right.svg';
import { classNames } from '../../utils/style';
import { ButtonV2 } from '../ButtonV2';
import { CarouselContext, CarouselContextType } from './CarouselContext';

type PaginationArrowDotsProps = {
  className?: string;
  isItemsCentered?: boolean;
};

export const PaginationArrowDots = ({
  className,
  isItemsCentered,
}: PaginationArrowDotsProps) => {
  const {
    elementSelected,
    classNamePagination,
    nbElement,
    isLoop,
    onClickDot,
    onClickNext,
    onClickPrev,
  } = useContext<CarouselContextType>(CarouselContext);
  const disabledRightState =
    (isItemsCentered
      ? elementSelected === nbElement - 1
      : elementSelected === nbElement - 3) && !isLoop;
  return (
    <div
      className={classNames(
        className,
        'PaginationArrowDots flex flex-row justify-evenly items-center',
        classNamePagination,
      )}
    >
      <ButtonV2
        variant="secondary"
        onClick={onClickPrev}
        isDisabled={elementSelected === 0 && !isLoop}
        className={classNames(
          'rounded-full !border-none shadow-none !px-12 !min-h-[48px]',
          elementSelected === 0 && !isLoop
            ? 'bg-lang-31 text-silver-100'
            : '!bg-neutral-21 text-navy-40',
        )}
        aria-label={'previous'}
      >
        <Chevron
          className={classNames(
            'h-24 w-24 rotate-180',
            elementSelected === 0 && !isLoop
              ? 'fill-[#D1DAE6]'
              : 'fill-[#768699]',
          )}
        />
      </ButtonV2>
      <div className="flex flex-row gap-3">
        {[...Array(nbElement)].map((value, index) => (
          <button
            key={index}
            className={classNames(
              'h-8 w-8 cursor-pointer',
              elementSelected === index ? 'bg-primary-1' : 'bg-lang-41',
            )}
            style={{ borderRadius: '50%' }}
            onClick={() => onClickDot && onClickDot(index)}
            aria-label={`slide n°${index + 1}`}
          />
        ))}
      </div>
      <ButtonV2
        variant="secondary"
        title="next"
        isDisabled={disabledRightState}
        className={classNames(
          'rounded-full !border-none shadow-none !px-12 !min-h-[48px] mr-16',
          disabledRightState
            ? 'bg-lang-31 text-silver-100'
            : '!bg-neutral-21 text-navy-40',
        )}
        onClick={onClickNext}
        aria-label="next"
      >
        <Chevron
          className={classNames(
            'h-24 w-24',
            disabledRightState ? 'fill-[#D1DAE6]' : 'fill-[#768699]',
          )}
        />
      </ButtonV2>
    </div>
  );
};

export default PaginationArrowDots;
